/**
 * 普通推免路由信息
 */
const examExempted = {
  name: 'examExempted',
  path: 'examExempted',
  component: resolve => require(['../../components/pages/examExempted'], resolve),
  redirect: 'examExempted/enroll/sign',
  children: [{
    path: 'enroll/sign',
    component: resolve => require(['../../components/pages/examExempted/enroll/sign'], resolve)
  }, {
    path: 'enroll/signResult',
    component: resolve => require(['../../components/pages/examExempted/enroll/sign/Result'], resolve)
  }, {
    path: 'enroll/signEdit',
    component: resolve => require(['../../components/pages/examExempted/enroll/signEdit'], resolve)
  }, {
    path: 'enroll/signEditResult',
    component: resolve => require(['../../components/pages/examExempted/enroll/signEdit/Result'], resolve)
  }, {
    path: 'query/reexamination',
    component: resolve => require(['../../components/pages/examExempted/query/reexamination'], resolve)
  }, {
    path: 'query/admission',
    component: resolve => require(['../../components/pages/examExempted/query/admission'], resolve)
  }, {
    path: 'upload/healthReport',
    component: resolve => require(['../../components/pages/examExempted/upload/healthReport'], resolve)
  }, {
    path: 'supplement',
    component: resolve => require(['../../components/pages/examExempted/supplement/ExemptedEnrollContactSupplement'], resolve)
  }]
}

export default examExempted



// WEBPACK FOOTER //
// ./src/router/pages/examExempted.js